import { FormContainerProps } from 'components/Forms/FormContainer';

import { CostCenterFormValues } from './validation';

export type ICostCenterFormProps = Pick<
  FormContainerProps<CostCenterFormValues>,
  'onSubmit' | 'initialValues' | 'buttons'
>;

export enum FieldLabel {
  Name = 'Cost center name *'
}
